/* global global_s_ss */
/* eslint-disable camelcase */
import $ from 'cash-dom';
import LazyLoad from 'vanilla-lazyload';

$(() => {
  const $colEven = $('.js-s_ss-col-even');

  if (typeof global_s_ss === 'undefined' || !$colEven.length) {
    return false;
  }

  const $colOdd = $('.js-s_ss-col-odd');
  const $btnPrev = $('.js-s_ss-prev');
  const $btnNext = $('.js-s_ss-next');
  const { stHalf, ndHalf } = global_s_ss;
  let page = 0;

  function setTranslate($el, value) {
    $el.css('transform', `translateY(${value})`);
  }

  function updateSliders() {
    setTranslate($colEven, `-${(100 / stHalf) * page}%`);
    setTranslate(
      $colOdd,
      page === ndHalf
        ? `${100 / ndHalf}%` // beyond last
        : `-${(100 / ndHalf) * (ndHalf - 1 - page)}%`
    );
  }

  $($btnPrev).on('click', () => {
    if (page === 0) {
      return false;
    }

    page--;
    return updateSliders();
  });

  $($btnNext).on('click', () => {
    if (page === stHalf - 1) {
      return false;
    }

    page++;
    return updateSliders();
  });

  return true;
});

// deal with mobile carousel async
// TODO create carousel.js
$(() => {
  const $carousel = $('#js-lazy-carousel');

  if (typeof global_s_ss === 'undefined' || !$carousel.length) {
    return false;
  }

  // Use Lazyload on desktop...
  if (window.innerWidth > 850) {
    if (document.getElementById('js-lazy-ss')) {
      const lazyLoadSlideshow = new LazyLoad({
        // eslint-disable-line no-unused-vars
        container: document.getElementById('js-lazy-ss'),
        elements_selector: '.js-lazy-ss',
        class_loaded: 'js-loaded',
      });
    }

    return false;
  }

  // ...otherwise make custom lazyload on mobile

  $carousel.children().each((index) => {
    $($carousel.children()[index]).removeClass('js-lazy');
    if (!$($carousel.children()[index]).hasClass('js-lazy-exclude')) {
      $($carousel.children()[index]).addClass('js-lazy-ss');
    }
  });

  const scrollArea =
    $carousel.innerHeight() * global_s_ss.ratio * global_s_ss.count;

  function lazySrc(el) {
    if (!el) return false;

    const image = new Image();

    image.src = el.getAttribute('data-lazy-ss-src');

    image.onload = () => {
      el.setAttribute('src', el.getAttribute('data-lazy-ss-src'));
      $(el).addClass('js-loaded-ss');
    };

    return true;
  }

  function lazyChildren(e) {
    const index = Math.floor(
      (e.currentTarget.scrollLeft * global_s_ss.count) / scrollArea
    );
    const offset = index + 3;

    lazySrc($carousel.children().get(offset));
    if (offset === global_s_ss.count - 1) {
      $($carousel).off('scroll', lazyChildren);
    }

    if (index > 0) {
      const el = $('.js-carousel-instruction')[0];

      if (index > 3 && el) {
        $(el).addClass('isHidden');
      }
    }
  }

  // Set first images
  lazySrc($carousel.children().get(0));
  lazySrc($carousel.children().get(1));
  lazySrc($carousel.children().get(2));

  $($carousel).on('scroll', lazyChildren);

  return true;
});
